import yup from '../../../../config/yup';

export const appendTaskValidationSchema = yup.object().shape({
  '@id': yup.string(),
  name: yup
    .string()
    .matches(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/, {
      message:
        'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
    })
    .required('Name is required'),
  type: yup.string().default('fileOperation'),
  function: yup.string().default('append'),
  parameters: yup.object().shape({
    importerRef: yup.string().required('Importer Reference is required'),
    outputConnector: yup.string().required('Output Connector is required'),
    inputTable: yup.string().required('Input Table is required'),
  }),
});
